import { render } from "./SectionHeader.vue?vue&type=template&id=1d877b8c&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=1d877b8c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d877b8c"]])

export default __exports__